import { Box, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

export default function Filters({
  companies,
  selectedIndustry,
  setSelectedIndustry,
  selectedCountry,
  setSelectedCountry,
  selectedStage,
  setSelectedStage,
}) {
  // Unique Industries (bucketed)
  const industryOptions = [
    ...new Set(
      companies
        .flatMap((c) => c.BucketIndustries || [])
        .filter((x) => typeof x === "string" && x.trim() !== "")
    ),
  ];

  // Unique Countries
  const countryOptions = [
    ...new Set(
      companies
        .map((c) => c["Headquarters Location"])
        .filter((x) => typeof x === "string" && x.trim() !== "")
    ),
  ];

  // Unique Investment Stages
  const stageOptions = [
    ...new Set(
      companies
        .map((c) => c["Investment Stage"])
        .filter((x) => typeof x === "string" && x.trim() !== "")
    ),
  ];

  return (
    <Box sx={{ display: "flex", gap: 2, marginBottom: 3 }}>
      {/* Industry */}
      <FormControl fullWidth>
        <InputLabel>Industry</InputLabel>
        <Select
          value={selectedIndustry}
          label="Industry"
          onChange={(e) => setSelectedIndustry(e.target.value)}
        >
          <MenuItem value="">All Industries</MenuItem>
          {industryOptions.map((industry, idx) => (
            <MenuItem key={idx} value={industry}>
              {industry}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Country */}
      <FormControl fullWidth>
        <InputLabel>Country</InputLabel>
        <Select
          value={selectedCountry}
          label="Country"
          onChange={(e) => setSelectedCountry(e.target.value)}
        >
          <MenuItem value="">All Countries</MenuItem>
          {countryOptions.map((country, idx) => (
            <MenuItem key={idx} value={country}>
              {country}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Investment Stage */}
      <FormControl fullWidth>
        <InputLabel>Investment Stage</InputLabel>
        <Select
          value={selectedStage}
          label="Investment Stage"
          onChange={(e) => setSelectedStage(e.target.value)}
        >
          <MenuItem value="">All Stages</MenuItem>
          {stageOptions.map((stage, idx) => (
            <MenuItem key={idx} value={stage}>
              {stage}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
